import { render, staticRenderFns } from "./form_tooltips.vue?vue&type=template&id=7c1774bb&lang=pug&"
import script from "./form_tooltips.vue?vue&type=script&lang=coffee&"
export * from "./form_tooltips.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports